import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
//import store from './store'

Vue.config.productionTip = false

Vue.directive('sticky',{
  bind: function (el, binding) {
    el.scrollEvent = function() {
      var offset = binding.value.offset;
      if(offset == 'vh')
        offset = window.innerHeight;
      if( window.innerWidth >= binding.value.minWidth){
        if(binding.arg == 'top' && window.scrollY >= offset){
          el.style.position = 'fixed';
          el.classList.add("el-fixed");
        }
        else{
          el.style.position = 'relative';
          el.classList.remove("el-fixed");
        }
      }
    }
    document.addEventListener('scroll', el.scrollEvent);
  }
});

new Vue({
  router,
  //store,
  render: h => h(App)
}).$mount('#app')
